let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f5EyQ")).then(() => parcelRequire('linO4'));